import React from 'react';
import { Typography } from 'src/components/PulseUI';

const StrategyDateAdded = ({ row }) => {
  const formatDate = (date: string) => {
    if (!date) return '';
    return new Date(date).toLocaleDateString('en-US', {
      month: 'long',
      day: 'numeric',
      year: 'numeric',
    });
  };
  return (
    <Typography className="text-sm text-primary whitespace-nowrap">
      {formatDate(row?.added_at) || ''}
    </Typography>
  );
};

export default StrategyDateAdded;
